import { render } from "./VideoViews.vue?vue&type=template&id=22348bff&scoped=true"
import script from "./VideoViews.vue?vue&type=script&lang=js"
export * from "./VideoViews.vue?vue&type=script&lang=js"

import "./VideoViews.vue?vue&type=style&index=0&id=22348bff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22348bff"]])

export default __exports__